import { useLocation, Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLoginPage() {
  const location = useLocation();
  const error = location.state?.error;

  const onLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div data-testid="admin-login-page">
      <PageHeader
        overline="Admin"
        title="Sign in to view messages."
        lede="This area is only for the site administrator. Sign in with the Google account that&rsquo;s been allow-listed."
      />
      <section className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-20">
        <div className="max-w-xl border border-rule bg-white p-10 md:p-12">
          {error && (
            <div
              data-testid="admin-login-error"
              className="mb-6 border-l-4 border-destructive bg-destructive/5 px-4 py-3 text-sm text-destructive font-accent"
            >
              {error}
            </div>
          )}
          <p className="text-ink-muted leading-relaxed">
            You&rsquo;ll be redirected to Google to sign in, then returned to this site.
          </p>
          <button
            onClick={onLogin}
            data-testid="admin-google-signin-button"
            className="mt-8 w-full inline-flex items-center justify-center gap-3 bg-river text-linen px-6 py-4 text-sm font-accent font-semibold tracking-wide hover:bg-river-dark transition-colors"
          >
            Continue with Google
          </button>
          <p className="mt-6 text-xs text-ink-muted font-accent">
            Only allow-listed accounts can access the admin panel. If your sign-in succeeds but you&rsquo;re shown a &ldquo;not authorised&rdquo; message, your email is not on the allowlist.
          </p>
          <div className="mt-8 pt-6 border-t border-rule">
            <Link
              to="/"
              data-testid="admin-back-home-link"
              className="text-sm font-accent text-ink-muted hover:text-ink"
            >
              ← Back to the public site
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
